import "./App.css";
import preval from "preval.macro";
import styled from "styled-components";
import { buildEnvironment, gameName } from "./env";
import { startCase } from "lodash";
import { UnityWebGLWrapper } from "./components/UnityWebGLWrapper";
import { Helmet } from "react-helmet";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const BUILD_DATE = preval`module.exports = new Date().toLocaleString();`;
const LOADING_STRING = " (Loading...)";

function App() {
  const [nameString, setNameString] = useState(gameName);
  const [versionString, setVersionString] = useState("");
  const [forceEnd, setForceEnd] = useState(false);
  function onRecievedVersionInfo(name: string, version: string) {
    setNameString(name);
    setVersionString(version);
  }
  const query = new URLSearchParams(useLocation().search);
  const env = query.get("env");
  const isDebug = query.get("oversight") === "0";
  let environment = env || buildEnvironment;
  let isProduction = environment === "production";
  useEffect(() => {
    if (isProduction) {
      if (versionString !== "") {
        console.log(`WebGL Game Loaded: ${nameString} v${versionString}`);
      } else if (nameString === "") {
        console.log(`WebGL Template Build Date: ${BUILD_DATE}`);
      }
    }
  }, [isProduction, versionString, nameString]);

  const MyUnity = isProduction ? FullScreenUnity : UnityWithFooter;
  let titleString = nameString;
  if (!isProduction && versionString.length > 0) {
    titleString += ` v${versionString}`;
  } else if (versionString.length === 0) {
    titleString += LOADING_STRING;
  }

  return (
    <Centred>
      <Helmet>
        <title>{titleString}</title>
      </Helmet>
      <MyUnity
        onRecievedVersionInfo={onRecievedVersionInfo}
        forceEnd={forceEnd}
      />
      {!isProduction && (
        <Footer>
          <span>
            {nameString}
            {versionString.length > 0 ? (
              <span> (v{versionString})</span>
            ) : (
              <span>{LOADING_STRING}</span>
            )}
          </span>
          <span>
            {startCase(environment)}
            {isDebug && <button onClick={() => setForceEnd(true)}>End</button>}
          </span>
          <span>Template Build Date: {BUILD_DATE}</span>
        </Footer>
      )}
    </Centred>
  );
}

const Centred = styled.div`
  text-align: center;
`;

const FullScreenUnity = styled(UnityWebGLWrapper)`
  margin: 0 auto;
  width: 100%;
  height: 100vh;
  max-height: -webkit-fill-available;
`;

const UnityWithFooter = styled(FullScreenUnity)`
  height: calc(100vh - 2.15em);
`;

const Footer = styled.div`
  position: fixed;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  width: calc(100% - 1em);
  padding: 0.5em;
  display: flex;
  justify-content: space-between;
`;

export default App;
